import React from "react";

export const TickGreyIcon = () => {
  return (
    <>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="9.5"
          cy="9.5"
          r="9.5"
          fill="#DDDDDD"
          style={{
            fill: "#DDDDDD",
            fill: "color(display-p3 0.8676 0.8676 0.8676)",
            fillOpacity: 1,
          }}
        />
        <path
          d="M4.33203 10.8333L6.7487 13.25L13.9987 6"
          stroke="white"
          style={{ stroke: "white", strokeOpacity: 1 }}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};
